var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('v-alert',{ref:"alert",staticClass:"alert--component-custom",attrs:{"dismissible":true,"type":_vm.type,"elevation":"2"},on:{"click":function($event){_vm.localShow = false}}},[_vm._v(" "+_vm._s(_vm.$t(_vm.message))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }